export default {
    LOAD_CLIENT(state, client) {
        state.items = client
    },

    LOAD_SELECT_CLIENT(state, response) {
        state.items_client = response
    }
}